module.exports = __webpack_public_path__ + "static/media/ana.1441454e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/ana.png
// module id = 1461
// module chunks = 0